import script from "./VacinaCriarEditar.vue?vue&type=script&setup=true&lang=js"
export * from "./VacinaCriarEditar.vue?vue&type=script&setup=true&lang=js"

import "./VacinaCriarEditar.vue?vue&type=style&index=0&id=24349952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24349952"]])

export default __exports__